import { PunchclockSettings } from 'type';

export default function makeFormFields(settings: PunchclockSettings) {
  return {
    ...settings,
  };
}

export type FormFields = ReturnType<typeof makeFormFields>;
